/**
 * @deprecated Use withLoggedUser Hoc on @domain/logged-user/logged-user.hocs
 */
export const mapLoggedUserToProps = state => ({
    loggedUser: state.loggedUser.data,
    objectSelected: state.data.objectSelected,
});
